<template>
    <div>
        <b-modal
            id="modalAnexoForm"
            v-model="mostrarModal"
            @show="abrirAnexoForm()"
            @hide="resetAnexoForm()"
        >
            <div slot="modal-title">
                Pagamento - Anexo -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Anexo</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposAnexosSelect"
                            v-model="tipoId"
                            text-field="descricao"
                            value-field="anexoTipoId"
                        ></b-form-select>
                    </b-form-group>
                    <b-alert show v-if="tipo && tipo.ajuda">{{
                        tipo.ajuda
                    }}</b-alert>
                </b-col>
            </b-row>
            <b-row v-if="possuiNumero">
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Numero {{ tipoNumero }}</label>
                        <b-form-input
                            type="text"
                            :placeholder='`Numero ${tipoNumero}`'
                            v-model="numero"
                            @input="$v.numero.$touch()"
                            :state="$v.numero.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O numero {{tipoNumero}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="temCodigo">
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Codigo de verificação</label>
                        <b-form-input
                            type="text"
                            placeholder="Codigo de verificação"
                            v-model="codigo"
                            @input="$v.codigo.$touch()"
                            :state="$v.codigo.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O código de verificação é obrigatorio</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>   
            <b-row v-if="temDataEmissao">
                <b-col sm="12" >
                    <b-form-group>
                        <label class="required">
                            Data Emissão
                        </label>
                        <date-picker
                            id="dataVencimento"
                            v-model="dataEmissao"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descritivo</label>
                        <b-form-input
                            type="text"
                            placeholder="Descritivo"
                            v-model="descritivo"
                            @input="$v.descritivo.$touch()"
                            :state="$v.descritivo.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O descritivo do anexo é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="operacao == 'INSERIR'">
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharAnexoForm()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarAnexo()"
                    class="ml-2"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'pagamento-anexo-form',

    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        operacao: {
            type: String, 
            default: () => 'INSERIR' 
        },

        anexoAtualizarId: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            obterPagamentoAtualizado: false,
            tiposAnexosSelect: [],
            tipoId: '',
            descritivo: '',
            numero: null,
            codigo: null,
            dataEmissao: null,
            arquivo: null,
            pagamentoAnexoId: null,
        }
    },

    methods: {
        abrirAnexoForm() {
            this.obterPagamentoAtualizado = false
            this.obterAnexosTipos()
            if (this.operacao == 'ATUALIZAR') {
                this.obterAnexo()
            }
        },

        fecharAnexoForm() {
            this.mostrarModal = false
            // this.resetAnexoForm()
            if (this.obterPagamentoAtualizado) {
                this.$emit('obterPagamentoAtualizado')
            }
        },

        resetAnexoForm() {
            this.descritivo = ''
            this.tipoId = ''
            this.numero = null
            this.codigo = null
            this.dataEmissao = null
            this.pagamentoAnexoId = null
            this.arquivo = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm(anexo) {
            this.pagamentoAnexoId = anexo.pagamentoAnexoId
            this.tipoId = anexo.anexoTipo.anexoTipoId
            this.descritivo = anexo.descricao
            this.numero = anexo.numeroNotaDocumento
            this.codigo = anexo.codigoVerificacao
            this.dataEmissao = anexo.dataEmissao != null ? this.$moment(anexo.dataEmissao).format('DD/MM/YYYY') : null
        },

        salvarAnexo() {
            this.mostrarModal = false
            this.$store.dispatch('addRequest')
            let anexoData = {
                pagamentoId: this.pagamento.pagamentoId,
                pagamentoAnexoId: this.pagamentoAnexoId,
                tipoId: this.tipoId,
                descritivo: this.descritivo,
                numeroNotaDocumento: this.possuiNumero == true ? this.numero : '',
                codigoVerificacao: this.temCodigo == true ? this.codigo : '',
                dataEmissao: this.temDataEmissao == true ? this.$moment(this.dataEmissao, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
                arquivo: this.arquivo
            }

            let salvarAnexo = null
            if (this.operacao == 'ATUALIZAR') {
                anexoData.pagamentoAnexoId = 
                salvarAnexo = this.pagamentosServicos.atualizarPagamentoAnexo(anexoData)
            } else {
                salvarAnexo = this.pagamentosServicos.inserirPagamentoAnexo(anexoData)
            }
                
            salvarAnexo.then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterPagamentoAtualizado = true
                        this.resetAnexoForm()
                        this.fecharAnexoForm()
                    } else {
                        this.erros = response.errors
                        this.mostrarModal = true
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAnexosTipos() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterAnexosTipos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposAnexosSelect = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de anexos!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAnexo() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterAnexo(this.anexoAtualizarId).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencherForm(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de anexos!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        tipo() {
            let tiposTemp = this.tiposAnexosSelect.find(
                (p) => p.anexoTipoId == this.tipoId
            )
            return tiposTemp ? tiposTemp : {}
        },

        tipoNumero() {
            if (this.tipo.categoria === 1) {
                return 'da nota fiscal' 
            } else if (this.tipo.categoria == 2) {
                return 'do documento'
            } else if (this.tipo.categoria == 3) {
                return 'de referência do documento'
            }
            return ''
        },

        temCodigo() {
            return this.tipo.categoria === 1
            
        },

        temDataEmissao() {
            return this.tipo.categoria === 2 || this.tipo.categoria === 3
        },

        possuiNumero() {
            return this.tipo.categoria !== 4 
        },
    },

    validations: {
        tipoId: {
            required
        },
        arquivo: {
            obrigatorio() {
                if (this.operacao == 'INSERIR') {
                    return this.arquivo != null
                }
                return true
            }
        },
        descritivo: {
            required
        },
        numero: {
            campoNumeroObrigatorio() {
                if (this.possuiNumero) {
                    return this.numero != '' && this.numero != null
                }
                return true
            }
        },
        codigo: {
            categoria() {
                if (this.temCodigo) {
                    return this.codigo != null && this.codigo != ''
                }
                return true
            }
        },
        dataEmissao: {
            categoria() {
                if (this.temDataEmissao) {
                    return this.dataEmissao != null && this.dataEmissao != ''
                }
                return true
            }
        }
    }
}
</script>
